import { CaretDimensions } from '../components/display/popovers/Popover/Popover.types';

export const CARET_DIMENSIONS_DEFAULT: CaretDimensions = {
  anchor: 'center',
  width: 14,
  height: 7,
};

export const TOOLTIP_OFFSET = {
  anchorBottom: -CARET_DIMENSIONS_DEFAULT.height,
  anchorTop: CARET_DIMENSIONS_DEFAULT.height,
};
